export default __webpack_public_path__ + "images/confetti.f82ce17463818106a90471ed56b5259f.png";